<template>
  <div id="pay-confirm"
       v-loading="loading"
       element-loading-text="拼命加载中">
    <div class="page-title">
      <img class="inline-block"
           src="@/assets/img/logo-mass.png"
           width="106"
           alt="center of mass" />
      <span class="inline-block">确认订单信息</span>
    </div>
    <div class="border-wrapper"
         v-if="needAddress">
      <p class="text-dark-subject"
         style="margin-right: 10px">请选择收货地址</p>
      <span class="tips">为保证及时收到资料，建议您将收货地址设置为学校地址。</span>
      <div class="address-entry-add"
           v-if="addresses.length < 7">
        <button class="btn btn-text address-action"
                @click="addAddresses({})">新增收货地址</button>
      </div>
      <slot v-for="(item, index) in addresses">
        <div @click="chosen(item.id)"
             :key="(index + 1)"
             v-if="Number(item.is_default) === 1 || index === 0 || showedAddresses"
             :class="'address-entry' + (Number(item.is_default) === 1?' default':'')">
          <div class="triangle"
               v-if="Number(item.is_default) === 1">
            <i class="fa-zhixin fa-check"
               style="color: #fff;"></i>
          </div>
          <div class="table-cell desp-ellipse pad-left-65"
               style="width: 96px;">{{ item.name }}</div>
          <div class="table-cell"
               style="width: 91px;">{{ item.mobile }}</div>
          <div class="table-cell "
               style="padding-left: 80px;max-width: 250px">
            {{ item.province }}{{ item.city }}{{ item.district }} {{ item.address }}
          </div>
          <div class="table-cell text-right"
               style="width: 100px">
            <span class="text-primary address-action"
                  @click="addAddresses(item)">修改</span>
            <span class="text-primary address-action"
                  @click="delAddresses(item.id)">删除</span>
          </div>
        </div>
      </slot>
      <div @click="showedAddresses = !showedAddresses"
           :class="'address-entry-more' + (showedAddresses ?' rotate': '')"
           v-if="addresses.length > 1">
        <span class="sublist-label">更多地址</span>
        <i class="fa fa-xiala"></i>
      </div>
    </div>
    <div class="order-title"
         v-if="!groupState">团购须知</div>
    <div class="order-xz"
         v-if="!groupState">
      <p>1. 拼团有效期内满足规则的人数参团并付款成功即为拼团成功，可在我的课程中看到所购买课程。</p>
      <p>2. 开团或参与团购并付款后，不可撤销拼团，在拼团有效期结束后如拼团失败，拼团会自动取消并退款。</p>
      <p>3. 拼团失败后，支付金额一般会在原渠道退回，到帐时间以微信、支付宝等支付平台为准。</p>
    </div>
    <div class="order-title">课程清单</div>
    <div v-for="(item, index) in classList"
         :key="index"
         class="confirmList">
      <div v-if="item.unionid>0"
           class="union-head">
        <div>
          <div class="sprite-lbshen lianbao-tag"></div>
          <span>{{item.title}}</span>
        </div>
        <div v-if="item.materialsSum">
          <i class="fa fa-zeng"
             style="color:#FFA000;transform: translateY(-2px);"></i>&nbsp;&nbsp;<span style="color:rgba(51,51,51,0.6)">联报赠品*{{item.materialsSum}}</span>
        </div>
      </div>
      <div class="order-all"
           v-for="(classInfo, index) in item.datalist"
           :key="index">
        <div class="class-img">
          <img :src="classInfo.cover?classInfo.cover:'https://image.eduzhixin.com/img/live/default-cover.png'"
               width="170"
               height="96"
               alt=""
               style="border-radius: 4px">
        </div>
        <div class="order-class">
          <div>{{classInfo.title}}</div>
          <div>授课老师：{{classInfo.teacher}}</div>
        </div>
        <div class="order-place">
          <div class="classinfo">
            <div>{{classInfo.begin_at|formatMD}}-{{classInfo.end_at|formatMD}}</div>|
            <!-- <div>{{classInfo.time_cycle.begin_at}}-{{classInfo.time_cycle.end_at}}</div>| -->
            <div v-if="classInfo.subs_info">共{{classInfo.subs_info.length}}节</div>
          </div>
          <!--        <div v-if="groupState" class="text-center">-->
          <!--          &lt;!&ndash; <div class="price gprice" v-if="classInfo.real_price !== classInfo.originalPrice">-->
          <!--            ¥{{classInfo.real_price/100}}-->
          <!--          </div> &ndash;&gt;-->
          <!--          <div class="price active-price" :style="couponPrice?'color: rgba(51, 51, 51, 0.6);':''">￥{{classInfo.originalPrice/100}}</div>-->
          <div>
            <div v-if="activity_type===0&&couponId===0"
                 class="text-center">
              <!-- <div
            class="price gprice"
            v-if="classInfo.real_price !== classInfo.originalPrice"
          >¥{{classInfo.real_price/100}}</div> -->
              <div class="price active-price">￥{{(classInfo.cartPrice)/100}}</div>
            </div>
            <!-- 优惠券价格 -->
            <div v-if="activity_type===0&&couponId!==0"
                 class="text-center">
              <div class="price active-price">￥{{Math.max(Number(((classInfo.cartPrice)/100).toFixed(2)),0)}}</div>
              <div class="price gprice">¥{{Number(classInfo.originalPrice)/100}}</div>
            </div>
            <!--  -->
            <div v-show="activity_type===2"
                 class="text-center">
              <div class="price active-price"
                   v-if="union_map && union_map[classInfo.union_id]">￥{{union_map[classInfo.union_id].goods_price[classInfo.goods_id]/100}}</div>
              <div class="price gprice">¥{{classInfo.real_price/100}}</div>
            </div>
            <div v-if="!groupState"
                 class="phonesty text-center">
              <div class="price">¥{{classInfo.cartPrice/100}}</div>
              <div class="price gprice">¥{{classInfo.real_price/100}}</div>
              <div class="gsign">团购价</div>
            </div>
            <div v-if="activity_type!==2&&(classInfo.material_goods_id)>0"
                 style="border-radius: 2px;padding:2px;font-size: 12px;background: rgba(198, 205, 218, 0.3);color: rgba(51, 51, 51, 0.5);">含{{materialPrice}}元教材费</div>
            <div v-if="activity_type===2&&(classInfo.material_goods_id)>0"
                 style="border-radius: 2px;padding:2px;font-size: 12px;background: rgba(198, 205, 218, 0.3);color: rgba(51, 51, 51, 0.5);">含{{classInfo.material_goods_price}}元教材费</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <CouponRange @getPrice="getOrderPrice"
                   ref="CouponRange"
                   :goodsid="couponGoodsid"></CouponRange>
    </div>
    <div class="order-count">
      <div class="count-all">
        <div class="count-info">
          <div>合计金额</div>
          <div>¥{{Number(((classInfo.originalPrice)/100))}}</div>
        </div>
        <div class="count-info">
          <div>活动优惠</div>
          <!-- <div v-if="couponId===0">-¥{{Math.max(Number(((classInfo.originalPrice - classInfo.cartPrice)/100).toFixed(2)),0)}}</div> -->
          <div v-if="couponId===0">-¥{{(classInfo.originalPrice - classInfo.cartPrice)|priceFilter}}</div>
          <div v-else-if="couponId>0">-¥0</div>
        </div>
        <div class="count-info">
          <div>礼券优惠</div>
          <div>-¥{{Number(couponPrice)}}</div>
        </div>
        <div class="count-info"
             style="align-items: baseline;margin-bottom:0px;">
          <div>应付金额</div>
          <!-- <div :class="!groupState?'realcountg':'realcount'">¥{{Math.max(Number(((classInfo.cartPrice)/100).toFixed(2)),0)}}</div> -->
          <div :class="!groupState?'realcountg':'realcount'">¥{{(classInfo.cartPrice)|priceFilter}}</div>
        </div>
      </div>
    </div>
    <div class="order-count address"
         v-if="needAddress && addresses.length">
      <div class="text-right">邮寄地址：{{address.province}} {{address.city}} {{address.district}} {{address.address}}</div>
      <div class="text-right">收件人：{{address.name}} {{address.mobile}}</div>
    </div>
    <div class="order-submit">
      <el-button type="primary"
                 @click="showJoinUpNow">提交订单</el-button>
    </div>
    <JoinUpNow ref="JoinUpNow"
               :classInfo="submitDate" />
    <Addresses ref="Addresses"
               :callback="handleAddresses" />
  </div>
</template>
<script>
import api from '@/api'
import $ from 'jquery'
import JoinUpNow from '@/components/JoinUpNow'
import Addresses from '@/components/Addresses'
import CouponRange from '@/components/CouponRange'
import { mapActions } from 'vuex'
import fliter from '@/utils/filters'

export default {
  name: 'confirm',
  data: function () {
    return {
      loading: true,
      classInfo: {
      },
      activity_type: 0, // 订单类型是否为团购  1为是 0为否
      groupState: true,
      class_type: '',
      classId: 0,
      handle: false,
      addressId: 0,
      addresses: [],
      needAddress: false,
      showedAddresses: false,
      couponPrice: 0, // 优惠券金额
      couponId: 0, // 优惠券id,
      orderInfo: {},
      goodsId: '',
      json: {
        goods_items: [{
          student_name: '',
          phone: '',
          school: '',
          grade: 0,
          goods_type: 5,
          goods_id: ''
        }]
      },
      classList: [], // 多个课程的列表
      union_map: {}, // 计算价格接口返回的, 联报小课价格
      needAddressMap: {},
      couponGoodsid: [],
      submitDate: {},
      materialPrice: '',
      unionMaterialList: [],
      zhuGeState: true
      // materialNeedArr: []
    }
  },
  components: { JoinUpNow, Addresses, CouponRange },
  created () {
    this.class_type = this.$route.params.class_type
    this.classId = this.$route.params.classId
    this.activity_type = Number(this.$route.params.activity_type)
    this.activityId = this.$route.query.activityId || 0
    this.isLive = this.class_type === 'live'
    this.groupState = Number(this.$route.params.activity_type) !== 1
    this.init()
    this.$nextTick(() => {
      $('.el-main').css('background', 'white')
    })
  },
  computed: {
    address () {
      return this.addresses.filter((item) => {
        return Number(item.is_default) === 1
      })[0] || {}
    }
  },
  filters: {
    priceFilter: function (value) {
      let sum = value
      sum = Math.max(Number((sum / 100).toFixed(2)), 0)
      return sum
    }
  },
  watch: {
    needAddress (val) {
      if (val) {
        this.getAddress()
      }
    }
  },
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  beforeDestroy () {
    $('.el-main').css('background', '')
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    ...mapActions(['getCartCount']),
    // isShowMaterial (value) {
    //   return this.materialNeedArr.indexOf(value) > -1
    // },
    handleTimeCycle (timeCycle) {
      let temp = ''
      if (timeCycle) {
        try {
          temp = JSON.parse(timeCycle)[0]
        } catch (error) {
          temp = ''
        }
      }
      return temp
    },
    init () {
      const classId = this.$route.params.classId
      const func = this.isLive ? 'getLiveClassDetail' : 'getClassDetail'
      api[func]({ class_id: classId }).then(r => {
        if (r.data.code === 1) {
          if (this.isLive) {
            const data = r.data.data.class_info
            let classInfoTemp = {
              title: data.subject,
              begin_at: data.begin_at,
              end_at: data.end_at,
              teacher: data.teachers,
              subs_info: data.subclass,
              // real_price: data.price,
              activity_type: this.activity_type,
              goods_id: Number(data.goods_id),
              time_cycle: this.handleTimeCycle(data.time_cycle),
              cover: data.cover
            }
            this.needAddress = Number(data.need_address) === 1
            if (this.needAddress) {
              this.getAddress()
            }
            if (this.activityId) {
              classInfoTemp = Object.assign({}, classInfoTemp, {
                activity_id: this.activityId
              })
            }
            this.classInfo = Object.assign({}, classInfoTemp)

            if (Number(this.activity_type) === 2) {
              this.getUnion(Number(data.goods_id))
            } else {
              this.couponGoodsid = [Number(data.goods_id)]
              const obj = {}
              obj.unionid = 0
              obj.datalist = []
              obj.datalist = [this.classInfo]
              this.classList = [obj]
              this.needAddressMap[data.goods_id] = Number(data.need_address) === 1
              this.needAddress = Number(data.need_address) === 1
              // this.$refs.CouponRange.getCoupon()
            }
          } else {
            const data = r.data.data
            // this.isShowMaterial = data.material_goods_id > 0
            // this.materialPrice = data.material_goods_price / 100
            this.materialPrice = fliter.handleCountPrice(data.material_goods_price / 100)
            this.classInfo = data
            this.classInfo.time_cycle = this.handleTimeCycle(data.time_cycle)
            // this.initCalCartPrice()
            if (Number(this.activity_type) === 2) {
              this.getUnion(Number(data.goods_id))
            } else {
              this.couponGoodsid = [Number(data.goods_id)]
              const obj = {}
              obj.unionid = 0
              obj.datalist = []
              obj.datalist = [this.classInfo]
              this.classList = [obj]
              // this.$refs.CouponRange.getCoupon()
            }
          }
          // this.loading = false
        }
      })
    },
    getAddress () {
      api.getAddress().then(res => {
        if (res.data.code === 1) {
          this.addresses = res.data.data.addresses
          this.sortAddresses()
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    handleAddresses () {
      if (this.handle) {
        this.addressId = ''
      }
      this.getAddress()
    },
    setDefault (id) {
      api.setDefault({ id }).then(res => {
        if (res.data.code === 1) {
          this.addresses.forEach((addr) => {
            addr.is_default = Number(addr.id) === Number(id) ? 1 : 0
          })
          this.sortAddresses()
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    sortAddresses () {
      this.addresses.sort(function (a, b) {
        return Number(b.is_default) - Number(a.is_default)
      })
      if (this.addresses.length) {
        const address = this.addresses.filter(item => {
          return Number(item.is_default) === 1
        })
        this.addressId = address.length ? address[0].id : ''
      }
    },
    chosen (id) {
      if (id === this.addressId) {
        return false
      }
      this.setDefault(id)
      this.showedAddresses = false
    },
    addAddresses (item) {
      this.handle = false
      this.$refs.Addresses.handle = JSON.stringify(item) !== '{}'
      this.$refs.Addresses.showDialog($.extend(true, {}, item))
    },
    delAddresses (id) {
      this.handle = true
      this.$refs.Addresses.deleteAddress(id)
    },
    initCalCartPrice () {
      if (this.fetchingunion) {
        this.loading = false
        return false
      }
      const goodsInfo = this.getGoodsInfo()
      if (Number(this.activity_type) === 1) {
        goodsInfo[0].activity_type = Number(this.activity_type)
        goodsInfo[0].activity_id = Number(this.activityId)
      }
      for (let i = 0; i < goodsInfo.length; i++) {
        if (this.$route.query.playBackList) {
          goodsInfo[i].offline_replay = 1
        } else {
          goodsInfo[i].offline_replay = 0
        }
      }
      api
        .calCartPrice({
          compute: true,
          coupon_id: this.couponId,
          goods_items: goodsInfo
        })
        .then(res => {
          if (res.data.code === 1) {
            const item = res.data.data
            this.classInfo.cartPrice = Number(item.cart_price) // 实际价格
            this.classList[0].datalist.map(classitem => {
              item.goods_discounts.map(unitem => {
                if (classitem.goods_id === unitem.goods_id) {
                  classitem.real_price = unitem.original_price
                }
              })
            })
            if (this.isLive) {
              this.union_map = res.data.data.union_map

              this.classInfo.originalPrice = Number( // 打折前价格
                item.original_price
              )
            } else if (this.activity_type === 2 && !this.isLive) { // 面授课的联报价格计算
              this.union_map = res.data.data.union_map
              this.classInfo.originalPrice = Number(item.original_price)
            } else {
              this.classInfo.originalPrice = Number(item.original_price)
            }
            const sum = item.original_price - item.cart_price
            if (this.couponId > 0) {
              this.couponPrice = sum / 100
            } else if (this.couponId === 0) {
              this.couponPrice = 0
            }
            // if (item.goods_discounts && this.activity_type !== 2) {
            //   item.goods_discounts.map(arr => {
            //     if (arr.product_type === 13) {
            //       this.materialNeedArr.push(arr.goods_id)
            //     }
            //   })
            // }
          }
          if (this.zhuGeState) {
            this.zhuGeEventTrack(this.zhugeEvents.VISIT_ORDER_CONFIRMING_PAGE, [
              this.needAddress,
              !!this.couponId,
              '课程详情页',
              Number((this.classInfo.originalPrice / 100).toFixed(2)),
              Number(((this.classInfo.originalPrice - this.classInfo.cartPrice - this.couponPrice * 100) / 100).toFixed(2)),
              this.isLive ? '直播课' : '面授课'
            ])
          }
          this.zhuGeState = false
          this.loading = false
        })
    },
    showJoinUpNow () {
      this.submitDate.needAddress = this.getNeedAddress(this.needAddressMap)
      this.submitDate.addressId = this.addressId
      this.submitDate.datalist = this.classList[0].datalist
      this.submitDate.needAddressMap = this.needAddressMap
      this.submitDate.goodsType = this.class_type === 'live' ? 2 : 5
      this.submitDate.activityId = this.$route.query.activityId || 0
      this.submitDate.classId = this.$route.params.classId
      if (this.class_type === 'live') {
        this.$refs.JoinUpNow.createOrder()
      } else {
        this.$refs.JoinUpNow.showDialog()
        this.$refs.JoinUpNow.getCacheOfflineOrder()
      }
    },
    submitOrder (json) {
      if (!this.isLive) {
        this.json.coupon_id = this.couponId
        let goodsItems = []// eslint-disable-line no-unused-vars
        goodsItems = this.classList[0].datalist.map(item => {
          const res = {
            goods_id: String(item.goods_id),
            activity_type: item.activity_type,
            phone: json.phone,
            grade: json.grade,
            school: json.school,
            student_name: json.student_name
            // extra: {
            //   activity_type: Number(this.activity_type)
            // }
          }
          if (this.needAddressMap[item.goods_id]) {
            res.address_id = Number(this.addressId)
          }
          if (item.union_id) {
            res.activity_id = Number(item.union_id)
            res.goods_type = item.goods_type
          } else {
            res.activity_id = Number(this.activityId)
            if (this.isLive) {
              res.goods_type = 2
            } else {
              res.goods_type = 5
            }
          }
          // if (item.activity_id) {
          //   res.extra.activity_id = item.activity_id
          // }
          return res
        })
        const data = {
          goods_items: goodsItems,
          // from_source: '质心灵动量',
          coupon_id: this.couponId
        }
        api.creatOrder(data).then(r => {
          if (r.data.code === 1) {
            this.getCartCount()
            this.$router.push({ path: '/pay/' + r.data.data.order_no })
          } else {
            this.$message.warning(r.data.message)
          }
        })
      } else {
        if (this.needAddress) {
          if (!this.addressId) {
            this.$message.warning('请选择邮寄地址')
            return false
          }
        }
        let goodsItems = []// eslint-disable-line no-unused-vars
        goodsItems = this.classList[0].datalist.map(item => {
          const res = {
            goods_id: String(item.goods_id),
            activity_type: item.activity_type
            // extra: {
            //   activity_type: Number(this.activity_type)
            // }
          }
          if (this.needAddressMap[item.goods_id]) {
            res.address_id = Number(this.addressId)
          }
          if (item.union_id) {
            res.activity_id = Number(item.union_id)
            res.goods_type = item.goods_type
          } else {
            res.activity_id = Number(this.activityId)
            if (this.isLive) {
              res.goods_type = 2
            } else {
              res.goods_type = 5
            }
          }
          // if (item.activity_id) {
          //   res.extra.activity_id = item.activity_id
          // }
          return res
        })
        const json = {
          goods_items: goodsItems,
          coupon_id: this.couponId
        }
        api.creatOrder(json).then(res => {
          if (res.data.code === 1) {
            this.$router.push({ name: 'Pay', params: { orderNo: res.data.data.order_no } })
          } else {
            this.$message.warning(res.data.message)
          }
          // else if (res.data.code === 20201) {
          //   this.$refs.JoinUpNow.unPayModalVisible = true
          // } else if (res.data.code === 20200) {
          //   this.$message.warning(res.data.msg)
          //   this.$router.push({ path: '/class-detail/' + this.classId + (this.isLive ? '/live' : '/offline') })
          // } else {
          //   this.$message.warning(res.data.msg)
          // }
          this.getCartCount()
        }, _ => {
          this.$message.error('系统错误，请稍后重试！')
          console.log(_)
        })
      }
    },
    // 获取优惠券金额
    getOrderPrice () {
      this.couponId = this.$refs.CouponRange.pickCoupon.pickId
      this.submitDate.couponId = this.couponId
      this.initCalCartPrice()
    },
    getGoodsInfo () {
      if (this.activity_type === 2) {
        if (this.classList[0].datalist.length) {
          return this.classList[0].datalist.map(item => {
            return {
              goods_id: String(item.goods_id),
              goods_type: item.goods_type
            }
          })
        } else {
          return ''
        }
      } else {
        return [
          {
            goods_id: String(this.classInfo.goods_id),
            goods_type: this.isLive ? 2 : 5
          }
        ]
      }
    },
    getNeedAddress (map = {}) {
      for (const key in map) {
        const element = map[key]
        if (element) {
          return true
        }
      }
      return false
    },
    getUnion (goodsId, history = 0, orderNo = null) {
      const data = {
        goods_id: goodsId,
        history
      }
      if (orderNo) {
        data.order_no = orderNo
      }
      const res = api.getLiveUnion(data)
      this.fetchingunion = true
      res.then(
        ({ data }) => {
          if (data.valid_order === 1 && this.mode === 'live') {
            this.$msgDialog('存在支付订单')
          }
          if (data.data && data.data.union_info.class_list) {
            let sum = 0
            this.unionInfo = data.data.union_info
            const obj = {}
            obj.datalist = []
            obj.unionid = data.data.union_info.union_id
            obj.price = data.data.union_info.discount_type === 1 ? data.data.union_info.discount_val / 10 : Number((data.data.union_info.discount_val / 100).toFixed(2))
            obj.title = data.data.union_info.discount_type === 1 ? `已打${obj.price}折` : `已减${Number(obj.price)}元`
            if (data.data.union_info.materials_info) {
              for (let i = 0; i < data.data.union_info.materials_info.length; i++) {
                sum += data.data.union_info.materials_info[i].quantity
              }
              obj.materialsSum = sum
            }
            this.unionInfo.class_list.forEach(item => {
              var obj = {
                material_goods_id: item.material_goods_id,
                material_goods_price: item.material_goods_price
              }
              this.unionMaterialList.push(obj)
            })
            const goodslist = []// eslint-disable-line no-unused-vars
            data.data.union_info.class_list.map(item => {
              goodslist.push(Number(item.goods_id))
            })
            this.couponGoodsid = goodslist
            // this.$refs.CouponRange.getCoupon()
            obj.datalist = data.data.union_info.class_list.map(item => {
              return {
                title: item.subject,
                goods_type: item.goods_type,
                subs_info: item.chapters,
                begin_at: item.begin_at,
                end_at: item.end_at,
                teacher: item.teachers,
                // real_price: item.price,
                activity_type: this.activity_type,
                union_id: data.data.union_info.union_id,
                goods_id: Number(item.goods_id),
                time_cycle: this.handleTimeCycle(item.time_cycle),
                material_goods_id: item.material_goods_id,
                material_goods_price: fliter.handleCountPrice(item.material_goods_price / 100)
              }
            })
            // console.log('data', obj)
            this.classList = [obj]
            this.gift_list = data.data.union_info.materials_info || []
            this.fetchingunion = false
            this.initCalCartPrice()
            if (this.isLive) {
              data.data.union_info.class_list.forEach(item => {
                this.needAddressMap[item.goods_id] = Number(item.need_address) === 1
                if (data.data.union_info.materials_info && data.data.union_info.materials_info.length > 0) {
                  this.needAddressMap[item.goods_id] = true
                }
              })
              this.needAddress = this.getNeedAddress(this.needAddressMap)
            }
          }
          if (data.msg === 'NotLogin') {
            // APP.notLogin(window.location.hash)
          }
        },
        () => {
          this.$msgDialog('网络错误, 稍后再试')
          this.visible = false
          this.fetchingunion = false
        }
      )
    },
    beforeunloadFn (e) {
      window.location.href = 'www.baidu.com'
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
// .el-main {
//   background: white;
// }
#pay-confirm {
  max-width: 1140px;
  // height: 944px;
  margin: auto;

  .page-title {
    display: flex;
    align-items: center;
    margin: 58px 0px 40px;

    .inline-block:nth-child(2) {
      font-size: 24px;
      font-family: $family;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-left: 16px;
    }
  }
  .class-img {
    img {
      margin-right: 12px;
    }
  }
  .order-xz {
    border-radius: 2px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    margin: 16px 0px 40px 0px;
    box-sizing: border-box;
    padding: 19px 29px 19px 32px;
    font-size: 14px;
    font-family: $family;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
  }
  .confirmList {
    margin: 16px 0px 24px 0px;
    .union-head {
      height: 48px;
      border: 1px solid rgba(51, 51, 51, 0.1);
      border-bottom: none;
      display: flex;
      align-items: center;
      padding: 0px 17px 0px 17px;
      box-sizing: border-box;
      color: #ffa000;
      justify-content: space-between;
    }
    .lianbao-tag:before {
      content: "";
      position: absolute;
      left: -20px;
      top: -12px;
      width: 80px;
      height: 48px;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      background-position: 0 -48px;
    }
  }
  .order-title {
    font-size: 16px;
    font-family: $family;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
    padding-left: 8px;
    border-left: 2px solid rgba(0, 199, 191, 1);
  }

  .order-submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;

    .el-button--primary {
      width: 152px;
      height: 48px;
      border-radius: 4px;
    }
  }

  .order-count {
    width: 100%;
    height: auto;
    border-radius: 1px;
    border: 1px solid rgba(51, 51, 51, 0.03);
    background: rgba(51, 51, 51, 0.03);
    box-sizing: border-box;
    padding: 24px 32px 24px 0px;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;

    .count-all {
      width: 184px;

      .count-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;

        div:nth-child(1) {
          font-size: 14px;
          font-family: $family;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.6);
          line-height: 14px;
        }
      }
    }
  }
  .active-price {
    color: #ffa000;
  }

  .order-count {
    width: 100%;
    height: auto;
    border-radius: 1px;
    border: 1px solid rgba(51, 51, 51, 0.03);
    background: rgba(51, 51, 51, 0.03);
    box-sizing: border-box;
    padding: 24px 32px 24px 0px;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;

    .count-all {
      width: 184px;

      .count-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;

        div:nth-child(1) {
          font-size: 14px;
          font-family: $family;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.6);
          line-height: 14px;
        }

        div:nth-child(2) {
          font-size: 14px;
          font-family: $family;
          font-weight: 500;
          color: rgba(51, 51, 51, 0.8);
          line-height: 14px;
        }

        .realcount {
          font-size: 22px !important;
          font-family: $family;
          font-weight: 500;
          color: rgba(255, 160, 0, 1) !important;
          line-height: 22px !important;
        }

        .realcountg {
          font-size: 22px !important;
          font-family: $family;
          font-weight: 500;
          color: #ef4d3c !important;
          line-height: 22px !important;
        }
        .count-info:nth-last-child(1) {
          margin-bottom: 0px;
        }
      }
    }
  }

  .order-all {
    width: 100%;
    height: 138px;
    border-radius: 2px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    background: white;
    // margin: 16px 0px 24px 0px;
    display: flex;
    align-items: center;
    padding: 0px 39px 0px 18px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    .order-class {
      // min-width: 388px;
      div:nth-child(1) {
        font-size: 16px;
        font-family: SFProDisplay-Medium, SFProDisplay;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        margin-bottom: 12px;
      }

      div:nth-child(2) {
        font-size: 14px;
        font-family: $family;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.79);
        line-height: 14px;
      }
    }

    .order-place {
      width: 36.7%;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-family: $family;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;

      .gprice {
        font-size: 14px;
        font-family: $family;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.3);
        text-decoration: line-through;
        margin-bottom: 5px;
      }

      .gsign {
        width: 42px;
        height: 21px;
        margin: auto;
        text-align: center;
        font-size: 11px;
        font-family: $family;
        font-weight: 400;
        color: rgba(239, 77, 60, 1);
        background: rgba(239, 77, 60, 0.12);
        line-height: 21px;
      }

      .classinfo {
        display: flex;
        font-size: 14px;
        font-family: $family;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.6);
        line-height: 14px;

        div {
          margin: 0px 8px;
        }
      }
    }
  }
}
//适配
@media (min-width: 300px) and (max-width: 320px) {
  #pay-confirm {
    margin-bottom: 18px;
    max-width: 355px;
    .order-xz {
      margin: 16px 0px 21px 0px;
    }
    .order-count {
      padding: 8px 11px 0px 0px;
    }
    .order-all {
      position: relative;
      height: 100px;
      padding: 16px 12px 0px 12px;
      align-items: baseline;
      display: inline-block;
      .order-class {
        max-width: 232px;
        margin-bottom: 12px;
      }
      .order-place {
        min-width: 100%;
        .text-center {
          margin-top: -52px;
        }
        .phonesty {
          max-width: 65px;
          position: absolute;
          right: 11px;
          top: 18px;
        }
      }
    }
    #couponrange {
      .pick_coupon {
        padding-left: 13px;
        .clear {
          left: 296px;
        }
      }
    }
    .page-title {
      margin: 12px 0px 22px;

      .inline-block:nth-child(2) {
        font-size: 20px;
        font-family: $family;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
      }
    }
  }
}
//适配
@media (min-width: 300px) and (max-width: 767px) {
  #pay-confirm {
    margin-bottom: 18px;
    max-width: 355px;

    .order-xz {
      margin: 16px 0px 21px 0px;
    }
    .order-count {
      height: auto;
      padding: 8px 11px 8px 0px;
    }

    .order-all {
      position: relative;
      // height: 100px;
      padding: 16px 12px 0px 12px;
      align-items: baseline;
      display: inline-block;

      .order-class {
        max-width: 232px;
        margin-bottom: 12px;
      }
      .order-place {
        display: inline-block;
        min-width: 270px;
        display: flex;
        .phonesty {
          max-width: 65px;
          position: absolute;
          right: 11px;
          top: 18px;
        }

        .order-place {
          // display: inline-block;
          min-width: 100%;

          .text-center {
            margin-top: -52px;
          }

          .phonesty {
            max-width: 65px;
            position: absolute;
            right: 11px;
            top: 18px;
          }

          // .price{
          //   position: absolute;
          //   top: 16px;
          //   right: 13px;
          // }
        }
        .classinfo {
          div {
            margin: 0px;
          }
        }
      }

      .page-title {
        margin: 12px 0px 22px;

        .inline-block:nth-child(2) {
          font-size: 20px;
          font-family: $family;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }
      }
      .class-img {
        display: none;
      }
    }
  }
}

@media (min-width: 768px) {
  #pay-confirm {
    max-width: 715px;

    .order-all {
      .order-place {
        width: 48.7%;
      }

      .order-class {
        min-width: 358px;
      }
    }
  }
}

@media (min-width: 992px) {
  #pay-confirm {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  #pay-confirm {
    max-width: 1140px;
    margin-bottom: 50px;

    .order-class {
      min-width: 388px;
    }
  }
}

#pay-confirm .border-wrapper {
  position: relative;
  border-radius: 2px 2px 0 0;
  padding: 32px;
  border: 1px solid rgba(51, 51, 51, 0.1);

  .btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    user-select: none;
    outline: none !important;
  }

  margin-bottom: 30px;

  .text-dark-subject {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 14px;
    margin-bottom: 15px;
    padding-left: 8px;
    border-left: 2px solid #00c7bf;
    display: inline-block;
  }

  .tips {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #ffa000;
  }

  .address-entry-more {
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    line-height: 20px;
    cursor: pointer;
    &.rotate {
      .fa {
        transform: rotateX(180deg);
        transition: all 0.4s ease;
      }
    }

    .fa {
      font-size: 11px;
      color: rgba(51, 51, 51, 0.4);
      margin: -3px 0 0 5px;
    }
  }

  .address-entry-add {
    position: absolute;
    top: 32px;
    right: 32px;

    .btn-text {
      border: none;
      padding: 0;
      height: auto;
      background: transparent;
      width: auto;
      color: #4196e6;
      font-weight: 400;
    }
  }

  .address-entry {
    display: table;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    border: 1px solid rgba(51, 51, 51, 0.1);
    position: relative;
    width: 100%;
    vertical-align: center;
    margin-bottom: 15px;

    &.default {
      border: 1px solid #00c7bf;
      .fa-check {
        left: 6px;
        top: -36px;
        position: absolute;
        z-index: 1;
      }
    }

    .triangle {
      position: absolute;
      width: 0;
      height: 0;
      top: 0;
      left: 0;
      border-top: 45px solid #00c7bf;
      border-right: 45px solid transparent;
    }

    .table-cell {
      display: table-cell;
      height: 45px;
      vertical-align: middle;
      text-align: left;
      padding: 0 5px;
      &.pad-left-65 {
        padding-left: 65px;
      }
      .text-primary {
        color: #4196e6;
        margin-right: 5px;
      }
      &.text-right {
        text-align: right;
      }
      @media screen and (max-width: 767px) {
        display: block;
        width: 100% !important;
        height: auto;
        padding: 0 !important;
        line-height: 1.5;
        margin-bottom: 10px;
        text-align: left !important;
        padding-left: 40px !important;
      }
    }
  }

  #pay-confirm .border-wrapper {
    position: relative;
    border-radius: 2px 2px 0 0;
    padding: 32px;
    border: 1px solid rgba(51, 51, 51, 0.1);

    .btn {
      display: inline-block;
      margin-bottom: 0;
      font-weight: normal;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      padding: 6px 12px;
      font-size: 14px;
      line-height: 1.42857143;
      border-radius: 4px;
      user-select: none;
      outline: none !important;
    }

    margin-bottom: 30px;

    .text-dark-subject {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      line-height: 14px;
      margin-bottom: 15px;
      padding-left: 8px;
      border-left: 2px solid #00c7bf;
      display: inline-block;
    }

    .tips {
      display: inline-block;
      font-size: 12px;
      font-weight: 400;
      color: #ffa000;
    }

    .address-entry-more {
      font-weight: 400;
      color: rgba(51, 51, 51, 0.6);
      line-height: 20px;
      cursor: pointer;
      &.rotate {
        .fa {
          transform: rotateX(180deg);
          transition: all 0.4s ease;
        }
      }

      .fa {
        font-size: 11px;
        color: rgba(51, 51, 51, 0.4);
        margin: -3px 0 0 5px;
      }
    }

    .address-entry-add {
      position: absolute;
      top: 32px;
      right: 32px;

      .btn-text {
        border: none;
        padding: 0;
        height: auto;
        background: transparent;
        width: auto;
        color: #4196e6;
        font-weight: 400;
      }
    }

    .address-entry {
      display: table;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      border: 1px solid rgba(51, 51, 51, 0.1);
      position: relative;
      width: 100%;
      vertical-align: center;
      margin-bottom: 15px;

      &.default {
        border: 1px solid #00c7bf;
      }

      .triangle {
        position: absolute;
        width: 0;
        height: 0;
        top: 0;
        left: 0;
        border-top: 45px solid #00c7bf;
        border-right: 45px solid transparent;
      }

      .table-cell {
        display: table-cell;
        height: 45px;
        vertical-align: middle;
        text-align: left;
        padding: 0 5px;
        &.pad-left-65 {
          padding-left: 65px;
        }
        .text-primary {
          color: #4196e6;
          margin-right: 5px;
        }
        &.text-right {
          text-align: right;
        }
      }
    }

    .desp-ellipse {
      height: 1.4em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .desp-ellipse {
    height: 1.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
